/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnhancedGovernance } from './EnhancedGovernance';
import {
  EnhancedGovernanceFromJSON,
  EnhancedGovernanceFromJSONTyped,
  EnhancedGovernanceToJSON,
} from './EnhancedGovernance';

/**
 *
 * @export
 * @interface PaginatedEnhancedGovernanceList
 */
export interface PaginatedEnhancedGovernanceList {
  /**
   *
   * @type {number}
   * @memberof PaginatedEnhancedGovernanceList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedEnhancedGovernanceList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedEnhancedGovernanceList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<EnhancedGovernance>}
   * @memberof PaginatedEnhancedGovernanceList
   */
  results: Array<EnhancedGovernance>;
}

/**
 * Check if a given object implements the PaginatedEnhancedGovernanceList interface.
 */
export function instanceOfPaginatedEnhancedGovernanceList(value: object): value is PaginatedEnhancedGovernanceList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedEnhancedGovernanceListFromJSON(json: any): PaginatedEnhancedGovernanceList {
  return PaginatedEnhancedGovernanceListFromJSONTyped(json, false);
}

export function PaginatedEnhancedGovernanceListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedEnhancedGovernanceList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(EnhancedGovernanceFromJSON),
  };
}

export function PaginatedEnhancedGovernanceListToJSON(value?: PaginatedEnhancedGovernanceList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(EnhancedGovernanceToJSON),
  };
}
